import React, {useCallback, useMemo} from "react";
import {useSelector, useDispatch} from "react-redux";
import Loader from "../../../../common/Loader";
import {uploaderSelector} from "../../../selectors";
import Image from "./Image";
import {uploadShutterstockImage} from "../../../AC/upload-shutterstock-image";
import Button from "@material-ui/core/Button";
import {
  incrementThirdPartySearchPage,
  search
} from "../../../AC/third-party-search";

export function ShutterStockResults() {
  const dispatch = useDispatch();
  const {
    uploader: {query, data, loading, loaded, page}
  } = useSelector((state) => ({
    uploader: uploaderSelector(state)
  }));

  const showMore = useCallback(() => {
    dispatch(incrementThirdPartySearchPage());
    dispatch(search());
  }, [dispatch]);

  const doesNextPageExist = useMemo(() => {
    if (!data || data.length === 0) {
      return false;
    }

    const perPage = data[0][`per_page`];
    const totalCount = data[0][`total_count`];
    const totalPages = Math.floor(totalCount / perPage);
    return page < totalPages;
  }, [data, page]);

  const imagesList = useMemo(() => {
    if (!data || data.length === 0) {
      return null;
    }

    return data.map((result) =>
      result.data.map((item) => (
        <div key={item.id} className="pictures__item">
          <Image
            url={item.assets[`huge_thumb`].url}
            previewSrc={item.assets[`huge_thumb`].url}
            alt={item.description}
            handleClick={(url) => () =>
              dispatch(uploadShutterstockImage(url, query, item))}
          />
        </div>
      ))
    );
  }, [data, dispatch, query]);

  return (
    <div className="google-search__content">
      <div className="pictures">
        {loading && !loaded && <Loader />}
        {imagesList}
      </div>
      <div className="pictures__more">
        {doesNextPageExist ? (
          <Button variant="outlined" onClick={showMore}>
            Показать ещё
          </Button>
        ) : null}
      </div>
    </div>
  );
}
